export default function urlTabs({ tabs, defaultTab, initial, query }) {
    return {
        tab: initial,
        onPopState: null,
        init() {
            this.onPopState = () => {
                const value = new URL(window.location.href).searchParams.get(query);
                this.tab = tabs.includes(value) ? value : defaultTab;
            };
            this.onPopState();
            window.addEventListener("popstate", this.onPopState);
            this.$watch("tab", (value) => {
                if (!tabs.includes(value)) return;
                const url = new URL(window.location.href);
                const current = url.searchParams.get(query);
                // Back/forward changes selection without creating another entry.
                if (value === (tabs.includes(current) ? current : defaultTab)) return;
                url.searchParams.set(query, value);
                window.history.pushState(window.history.state, "", url);
            });
        },
        destroy() {
            window.removeEventListener("popstate", this.onPopState);
        },
    };
}
